// extracted by mini-css-extract-plugin
module.exports = {"root":"ProductDiscountMessage_root__xpsUD"};